var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"purchase-tracker","data-order":"$ProcessedOrderID"}},[(_vm.getSessionOrder && _vm.getSessionOrder.ID)?_c('div',{class:_vm.purchaseTracking(_vm.getSessionOrder)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }